import React, { useState } from "react"
import { graphql } from "gatsby"
import Seo from "../components/seo"
import rehypeRaw from "rehype-raw"
import ReactMarkdown from "react-markdown"
import { getStringFromElement, stringToSlug } from "../utils/gatsby-helpers"
import NewLayout from "../components/new_layout"

const TermsUse = ({ data, pageContext }) => {
    const page = data.page.edges[0].node

    //let isScrolling = false
    let indexItems = []
    //let positions = []

    if (typeof window !== `undefined` && typeof document !== `undefined`) {
        const e = document.createElement("div")

        e.innerHTML = page.description

        e.querySelectorAll("h3").forEach((element, index) => {
            indexItems.push(element.innerText)
        })
    }

    const elements = {
        h3: ({ node, ...props }) => {
            const element = <h2 {...props} />
            const stringElement = getStringFromElement(element)
             
            return <h3 id={stringToSlug(stringElement)} {...props} />
        },
    }

    return (
        <NewLayout pageContext={pageContext}>
            <Seo lang={pageContext.langKey} title={page.seo.title} description={page.seo.meta_description} translates={pageContext.translates} />

            <main className="main">
                <div className="main__section main__section--20-80">
                    <div className="container">
                        <div className="hidden-lg">
                            <div className="container__index">
                                {indexItems.map((item, index) => {
                                    const slug = stringToSlug(item)
                                    return <a href={`#${stringToSlug(item)}`}>{item}</a>
                                })}
                            </div>
                        </div>
                        <div className="container__text">
                            <h1 className="hero">{page.title}</h1>
                            <div className="container__text__text">
                                <ReactMarkdown children={page.short_description} rehypePlugins={[rehypeRaw]} components={elements}/>
                                <div className="list-table">
                                    {page.items.map((item, index) => (
                                        <div key={index} className="list-table__item">
                                            <h6>{item.title}</h6>
                                            <ReactMarkdown children={item.description} rehypePlugins={[rehypeRaw]} />
                                        </div>
                                    ))}
                                </div>
                                <ReactMarkdown children={page.description} rehypePlugins={[rehypeRaw]} components={elements}/>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </NewLayout>

    )
}

export default TermsUse

export const termsUsePageQuery = graphql
    `query($langKey: String) {
    page: allStrapiLegalCondicionesDeUso (
        filter: { locale: { eq: $langKey } }
    ) {
        edges {
            node {
                id,
                seo {
                    title,
                    meta_description
                }
                title
                short_description
                items {
                    order
                    title
                    description
                }
                description
            }
        }
    }
}`
